import { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";

import Profile from "./Profile";
import FullScreen from "./FullScreen";
import MobileSection from "./MobileSection";
import SelectLibrary from "./Profile/SelectLibrary";
import useConfig from "hooks/useConfig";
import { MenuOrientation } from "config";
import DrawerHeader from "layout/Dashboard/Drawer/DrawerHeader";
import { useMemo } from "react";
import { useGetMenu } from "api/menu";
import Search from "./Search";
import Customization from "./Customization";
import useAuth from "hooks/useAuth";

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const { libraries, menuLoading, selectedLibrary } = useGetMenu();
  const { menuOrientation } = useConfig();
  const { modules } = useAuth();

  const downLG = useMediaQuery((theme: Theme) => theme.breakpoints.down("lg"));

  const activeLibrary = useMemo(() => {
    if (!libraries || !selectedLibrary) return null;
    return libraries.find(
      (lib: { id: string | number; name: string; libraryCode?: string }) =>
        String(lib.id) === String(selectedLibrary)
    );
  }, [libraries, selectedLibrary]);

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && (
        <DrawerHeader open={true} />
      )}
      <Typography sx={{ textWrap: "nowrap", mx: "8px" }} variant="h4">
        {menuLoading ? (
          <Skeleton animation="wave" width={200} />
        ) : activeLibrary ? (
          activeLibrary.name
        ) : (
          <></>
        )}
      </Typography>
      <Box sx={{ flexGrow: 1 }} />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        {!downLG && <Search />}
        {!downLG && <FullScreen />}
        {/* {modules?.library?.permissions.List && !downLG && <Customization />} */}
        <SelectLibrary />
        {!downLG && <Profile />}
        {downLG && <MobileSection />}
      </Box>
    </Box>
  );
}
